import { LIBRARY_ITEM_URL } from '@/consts/urls';
import { fetchLibraryData } from './utils';

import type { Preset } from '@/types';

type ResponseType = {
  data: Preset;
};

const getLibraryItemInfo = async (slug: string): Promise<Preset | null> => {
  return fetchLibraryData(`${LIBRARY_ITEM_URL}/${slug}`, (response) => {
    const data = response as ResponseType;
    return data.data;
  });
};

export { getLibraryItemInfo };
